// Shared building blocks for the two stay-entry forms (guest /abrechnung and
// external /gast-abrechnung). The two forms have the same nights-table +
// amount + payment + notes shape; only the top section (contact block) and
// the submit destination differ. Keeping these helpers in one place ensures
// the two forms can't drift on per-night math, CHF parsing, or row formatting.

export type NightRow = {
  date: string;
  members_adult: number;
  members_child: number;
  guests_adult: number;
  guests_child: number;
};

export const blankNight = (date: string): NightRow => ({
  date,
  members_adult: 0,
  members_child: 0,
  guests_adult: 0,
  guests_child: 0,
});

export const sumNight = (n: NightRow): number =>
  (Number(n.members_adult) || 0) +
  (Number(n.members_child) || 0) +
  (Number(n.guests_adult) || 0) +
  (Number(n.guests_child) || 0);

export function parseChf(s: string): number {
  const cleaned = s.replace(',', '.').trim();
  if (!cleaned) return 0;
  const n = Number.parseFloat(cleaned);
  if (!Number.isFinite(n) || n < 0) return Number.NaN;
  return Math.round(n * 100);
}

export function formatChfFromRappen(rappen: number): string {
  if (!Number.isFinite(rappen)) return '';
  return (rappen / 100).toFixed(2);
}

export function formatDate(date: string, lang: string): string {
  const [y, m, d] = date.split('-').map(Number);
  return new Intl.DateTimeFormat(lang, {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(y!, m! - 1, d!)));
}
